import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f5ae32ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "popup"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(_Transition, null, {
    default: _withCtx(() => [
      (_ctx.isOpen)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "backdrop",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.toggle(false)), ["self"]))
          }, [
            (_ctx.isOpen)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createElementVNode("button", {
                    class: "close",
                    title: "Close",
                    "aria-label": "Close",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggle(false))),
                    ref: "closeBtn"
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['far','xmark'] })
                  ], 512),
                  _renderSlot(_ctx.$slots, "default", {}, undefined, true)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}